import { http } from './http'
import { auth } from './auth'
import { z } from 'zod'
import { RedactedSnapshotSchema, SnapshotSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'
import { CreateSnapshotPayload } from '../types'

export const SnapshotResponseSchema = z.object({
  snapshot: SnapshotSchema,
})
const SnapshotListResponseSchema = z.object({
  snapshots: z.array(SnapshotSchema),
})

const RedactedSnapshotListResponseSchema = z.object({
  snapshots: z.array(RedactedSnapshotSchema),
})

export const snapshots = {
  getAll: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deals/${dealId}/snapshots`, undefined, dealId)
    return parseWithZod(SnapshotListResponseSchema, result).snapshots
  },

  getAllRedacted: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(
      `${regionHost}/api/deals/${dealId}/redacted_snapshots`,
      undefined,
      dealId,
    )
    return parseWithZod(RedactedSnapshotListResponseSchema, result).snapshots
  },

  create: async (payload: CreateSnapshotPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/snapshots`, payload, dealId)
    return parseWithZod(SnapshotResponseSchema, result).snapshot
  },
}
